import { useOptionPrice as usePrice } from "@/components/features/items/edit/option/_shared/ui/components/price/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionPrice = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { optionType, price, billingTypeTerm } = viewModel;

	return usePrice({ onSetViewModel, price, billingTypeTerm, optionType });
};
